export class ProductColours extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.render()
  }

  async render () {
    const currentHandle = this.dataset.url
    if (!currentHandle) return

    return new Promise(() => {
      fetch(`${currentHandle}?view=colourcount`)
        .then(r => {
          // Handles that don't exist will return a 404
          if (r.status === 200 && r.redirected === false) {
            return r.text()
          } else {
            return null
          }
        })
        .then(r => {
          if (r) {
            this.innerHTML = r
          }
          return null
        })
    })
  }
}

if (!customElements.get('product-colours')) {
  customElements.define('product-colours', ProductColours)
}
